import React from "react";
import { Divider as MuiDivider } from "@mui/material";

const Divider = () => {
	return (
		<MuiDivider
			className="entity-icons-divider"
			style={{
				position: "relative"
			}}
		/>
	);
};

export default Divider;
